export default __webpack_public_path__ + "static/media/adam.9b97e4e6.jpg";